import { Capacitor, registerPlugin } from '@capacitor/core';

interface NativeAppleSignInResult {
  identityToken: string;
  authorizationCode?: string | null;
  nonce: string;
  email?: string | null;
  givenName?: string | null;
  familyName?: string | null;
  user: string;
}

interface AppleSignInPlugin {
  signIn(): Promise<NativeAppleSignInResult>;
}

const AppleSignIn = registerPlugin<AppleSignInPlugin>('AppleSignIn');

export function isNativeAppleSignInRuntime(): boolean {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
}

export async function signInWithNativeApple(): Promise<NativeAppleSignInResult> {
  if (!isNativeAppleSignInRuntime()) {
    throw new Error('Native Apple Sign In is only available on iOS.');
  }

  return AppleSignIn.signIn();
}
